// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__Z2wzZ","header":"MessagesList_header__34fh8","chat":"MessagesList_chat__1Zd_X"};